import { useCallback } from 'react';

import { useBondsInfoRequest } from '@services/api/bonds/bonds.api';

import { toBN } from '@utils/formaters.utils';

import { CHAIN_ID } from '@constants/common/chain.constants';
import { TOKENS, TokenSymbol } from '@constants/common/tokens.constants';

const BONDS_CHAIN_ID = CHAIN_ID.BASE;
const NATIVE_TOKEN = TOKENS[BONDS_CHAIN_ID][TokenSymbol.ETH];

const useBondsInfo = () => {
  const { data, isPending, refetch } = useBondsInfoRequest();

  const handleUpdate = useCallback(async () => {
    await refetch();
  }, []);

  return {
    data: data
      ? {
          nativePrice: toBN(data.nativePrice),
          fundWallet: data.FUND_WALLET,
          bondFundWalletUsd: data.bondFundWalletUsd,
          bondPrice: toBN(data.currentNftPriceNative),
          bondPriceUsd: toBN(
            data.currentNftPriceNative,
            NATIVE_TOKEN.decimals,
          ).times(data.nativePrice),
          nativeToken: NATIVE_TOKEN,
          chainId: BONDS_CHAIN_ID,
          isNftPriceValid: data.isNftPriceValid,
          // Default to enabled when the backend omits the flag, so the
          // MintDisabledBanner only appears when minting is explicitly disabled.
          isEnabled: data.isEnabled ?? true,
        }
      : null,
    isPending,
    refetch: handleUpdate,
  };
};

export default useBondsInfo;
